import {
  UPDATE_EDITOR_MODE,
  TOGGLE_MY_INFO_LAYER,
  CLOSE_MY_INFO_LAYER,
  CHANGE_EDITOR_STATUS,
  UPDATE_TOOLBAR_LEFT,
  POST_CHANGED,
  SHOW_FOOTER,
  HIDE_FOOTER,
  UPDATE_MESSAGE,
  FOOTER_CHANGE_STATUS_TEXT,
  EDITOR_INITIALIZED,
  RED_TITLE_PLACEHOLDER,
  FOOTER_TOGGLE_STATUS_TEXT
} from "../constants/ActionTypes";

export const updateEditorMode = mode => ({
  type: UPDATE_EDITOR_MODE,
  mode
});

export const toggleMyInfoLayer = () => ({
  type: TOGGLE_MY_INFO_LAYER
});

export const closeMyInfoLayer = () => ({
  type: CLOSE_MY_INFO_LAYER
});

export const changeEditorStatus = (status) => ({
  type: CHANGE_EDITOR_STATUS,
  status
});

export const updateToolbarLeft = (left) => ({
  type: UPDATE_TOOLBAR_LEFT,
  left
});

export const postChanged = (changed) => ({
  type: POST_CHANGED,
  changed
});

export const showFooter = () => ({
  type: SHOW_FOOTER
});

export const hideFooter = () => ({
  type: HIDE_FOOTER
});

export const updateMessage = (message) => ({
  type: UPDATE_MESSAGE,
  message
});

export const updateFooterStatusText = text => ({
  type: FOOTER_CHANGE_STATUS_TEXT,
  value: text
});

export const toggleFooterStatusText = show => ({
  type: FOOTER_TOGGLE_STATUS_TEXT,
  show
});

export const notifyEditorInitialized = () => ({
  type: EDITOR_INITIALIZED
});

export const setTitlePlaceholderColorRed = flag => ({
  type: RED_TITLE_PLACEHOLDER,
  flag
});
